const fonts = {
    body: 'poppins, sans-serif',
    heading: 'poppins, sans-serif',
    poppins: 'poppins',
}

export default fonts